import PropTypes from "prop-types";

const GroupPermissionsPropType = PropTypes.shape({
  areGroupsInAccessGroupIdsHierarchy: PropTypes.bool,
  updateGroupAttributes: PropTypes.bool,
  canMutateGroup: PropTypes.bool,
  canMutateMemberships: PropTypes.bool,
  canEditPlanning: PropTypes.bool,
  __typename: PropTypes.string,
});

export default GroupPermissionsPropType;
